import { Injectable } from "@angular/core";
import { HelperService } from "../shared/services/helper.service";
import { environment } from "../../environments/environment";
import { HttpService } from "../shared/services/http.service";
import { ParameterModel } from '../models/parameter.model';

@Injectable()
export class ParameterService {

  private PARAMETER_ENDPOINT: string = '/giftCardVirtual';
  private BASE_URL: string = HelperService.buildRequestURL(environment.RipleyGiftCardVirtualApiEndPoint);
  private REQUEST_URL: string = `${this.BASE_URL}${this.PARAMETER_ENDPOINT}`;
  private URL: string;

  constructor(private httpService: HttpService) { }

  public GetGiftCardParameters() {
    this.URL = `${this.REQUEST_URL}/getGiftCardParameters`;
    return this.httpService.get<ParameterModel[]>(this.URL);
  }

  public SaveParametersSession(parameters: ParameterModel[]){
    sessionStorage.setItem("parametersList", JSON.stringify(parameters));
  }
}
